import React from 'react';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import { l10n } from '../i18n/Localization';

const Navbar = (props) => {
  const { authCompleted, user, authError } = props.authState;
  const { initializeCompleted, initializeResult, initializeError } = props.appState;

  let panel;
  if (authCompleted) {
    if (authError !== null) {
      panel = (
        <div>{l10n.navbar.userError}</div>
      );
    } else {
      if (user !== null) {
        if (initializeCompleted) {
          if (initializeError !== null) {
            panel = (
              <div>{l10n.navbar.initializeFailed}</div>
            );
          } else {
            if (initializeResult !== null) {
              panel = (
                <div>
                  <Link className="btn btn-warning" to="/sign-out">{l10n.auth.signOut}</Link>
                </div>
              );
            } else {
              panel = null;
            }
          }
        } else {
          panel = (
            <div>{l10n.navbar.initializing}</div>
          );
        }
      } else {
        panel = (
          <div>
            <Link className="btn btn-outline-success mr-2" to="/sign-up">{l10n.auth.signUp}</Link>
            <Link className="btn btn-success" to="/sign-in">{l10n.auth.signIn}</Link>
          </div>
        );
      }
    }
  } else {
    panel = (
      <div>{l10n.auth.authenticating}</div>
    );
  }

  return (
    <nav className="navbar navbar-expand-md navbar-dark bg-dark">
      <Link className="navbar-brand" to="/">{l10n.productName}</Link>
      <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarNav">
        <ul className="navbar-nav mr-auto">
          <li className="nav-item">
            <NavLink className="nav-link" exact strict to="/characters/">Characters</NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" exact strict to="/characters/identify">Identify Character</NavLink>
          </li>
          {/* <li className="nav-item">
            <NavLink className="nav-link" exact strict to="/">Cheaters</NavLink>
          </li> */}
          <li className="nav-item">
            <NavLink className="nav-link" exact strict to="/articles/">Articles</NavLink>
          </li>
        </ul>
        {panel}
      </div>
    </nav>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    appState: { ...state.appState },
    authState: { ...state.authState },
  };
};

export default connect(mapStateToProps)(Navbar);
